const currentHost = window.location.hostname;
// Local development and mobiliis2 staging only.
let apiUrl;
if (currentHost.includes('localhost') || currentHost.includes('127.0.0.1')) {
  apiUrl = 'http://127.0.0.1:8000';        // local development
} else if (currentHost.includes('mobiliis2.com')) {
  apiUrl = 'https://laravel.mobiliis2.com'; // staging
} else if (currentHost.includes('mobiliis1.com')) {
  apiUrl = 'https://laravel.mobiliis1.com'; // mobiliis1
} else {
  console.error('ApiConfig: unrecognised host "' + currentHost + '" — no API URL configured.');
  apiUrl = '';
}

export default {
  serverDevURL: apiUrl,
  serverProURL: apiUrl,
  accountProUrl: apiUrl,
  basePath: '/api/',
  headers: {
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache'
  },
  timeOut: 60000,
};
